module.exports = __webpack_public_path__ + "img/btnC.d61ad9b6.png";